import { jsxs as t, jsx as e } from "react/jsx-runtime";
import n from "../FlowingReviewRibbon/SimplyMark_.js";
import '../../assets/index6.css';const c = "_badge_yeu2c_2", l = "_logo_yeu2c_13", s = "_iconWrap_yeu2c_20", r = "_icon_yeu2c_20", i = {
  badge: c,
  logo: l,
  iconWrap: s,
  icon: r
};
function h({
  darkMode: o = !1
}) {
  return /* @__PURE__ */ t(
    "a",
    {
      className: i.badge,
      style: {
        backgroundColor: o ? "#222" : "#f9f9f9",
        color: o ? "#fff" : "#222"
      },
      href: "https://www.simplyreview.com",
      target: "_blank",
      children: [
        /* @__PURE__ */ e("div", { style: { fontSize: 11 }, children: "Made with" }),
        /* @__PURE__ */ e(
          "span",
          {
            style: {
              fontSize: 11,
              display: "flex",
              gap: 2,
              fontWeight: 500,
              alignItems: "center"
            },
            children: /* @__PURE__ */ e(n, { width: 84, height: 22, darkMode: o })
          }
        ),
        /* @__PURE__ */ e(
          "div",
          {
            className: i.iconWrap,
            style: {
              backgroundColor: o ? "#444" : "#e3e3e3"
            },
            children: /* @__PURE__ */ e("svg", { viewBox: "0 0 24 24", className: i.icon, children: /* @__PURE__ */ e(
              "path",
              {
                d: "M5 12h13M12 5l7 7-7 7",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2"
              }
            ) })
          }
        )
      ]
    }
  );
}
export {
  h as MadeWithSimplyReview
};
